import Reflux from 'reflux';

let CuesheetCursorActions = Reflux.createActions({
  moveCursorLeft: {},
  moveCursorRight: {},
  moveCursorToNextTitleRowAbove: {},
  moveCursorToNextTitleRowBelow: {},
  moveCursorUp: {},
  moveCursorDown: {},
  clearCursor: {},
  clearEditing: {},
  selectLastCellSelected: {},
  deleteScrollToSelectedCell: {},
  moveCursorFirstRow: {},
  moveCursorLastRow: {},
});

export default CuesheetCursorActions;
